<template>
    <section id="photo-gallery">
        <div class="container container-xl-fluid">
            <div class="secondary-heading text-center">ESSENS KICK OFF</div>
            <h1 class="text-center mb-3"> {{ $t('webGallery') }} </h1>
             <p class="text-center mb-4">
                <a href="https://static.essensworld.com/images/kickoff_26/web/russia.zip" 
                    target="_blank" 
                    rel="noopener">
                    <i class="fa fa-cloud-download" aria-hidden="true" style="color: var(--secondary); font-size: 20px;"></i>
                </a>
            </p>
            <div class="row">
                <div v-for="gallery in galleries" :key="gallery" class="col-xl-6 col-lg-6 col-12 my-6 my-lg-6 px-lg-6 mx-auto">
                    <router-link :to="gallery.href" class="gallery-thumbnail d-block text-center">
                        <img :src="gallery.imgSrc" :alt="gallery.name + ' image'">
                        <img class="mt-3 mb-1" :src="'https://www.essenskickoff.com/2022/img/flag/'+gallery.flag+'.png'" alt="United Kingdom" style="width: 25px;">
                        <div class="thumbnail-h ">{{ gallery.name }}</div>
                        <!-- <button class="btn btn-primary d-table mx-auto mt-3">Zobrazit</button> -->
                    </router-link>
                </div>
            </div>

        
        </div>
    </section>
</template>

<script setup>

    const galleries = [
        { name: 'Russia', imgSrc: 'https://static.essensworld.com/images/kickoff_26/web/russia/Image00038.jpg', href: '/gallery/russia', flag: 'ru' },
    ]
</script>

<style>  

    #photo-gallery {
        background-color: var(--grey-bg);
    } 

    .thumbnail-h {
        color: var(--primary);
        text-align: center;
        font-size: 1.5rem;
        font-weight: 500;
    }

    .gallery-thumbnail {
        /* border: 1px solid var(--secondary); */
    }
</style>